// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__AsCZ6","header":"Accordion_header__4UVDa","content":"Accordion_content__jxbkt"};